/* global Intl */
export function processTimeStamp(utcTime) {
    try {
        // Directly parse the ISO 8601 timestamp (timestamp to CST)
        const utcDate = new Date(utcTime);
        
        // Validate the date is valid
        if (isNaN(utcDate.getTime())) {
            console.error('Invalid date in processTimeStamp:', utcTime);
            return 'Invalid Date';
        }

        const options = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit", // Added for hh:mm:ss fidelity
            hour12: true,  // For AM/PM format
            timeZone: "America/Chicago" // Convert UTC time to Chicago time (Central Time)
        };

        // Use Intl.DateTimeFormat for better Safari compatibility
        // This is more reliable than toLocaleString in Safari on iOS
        let formatted;
        try {
            const formatter = new Intl.DateTimeFormat("en-US", options);
            formatted = formatter.format(utcDate);
        } catch (intlError) {
            // If Intl.DateTimeFormat fails, try toLocaleString
            formatted = utcDate.toLocaleString("en-US", options);
        }
        
        // Safari on iOS can return empty string or undefined - add fallback
        if (!formatted || formatted.trim() === '' || formatted === 'Invalid Date') {
            // Fallback: use basic formatting without timezone conversion
            // This ensures we always return something visible
            const fallbackOptions = {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true
            };
            
            try {
                const fallbackFormatter = new Intl.DateTimeFormat("en-US", fallbackOptions);
                formatted = fallbackFormatter.format(utcDate);
            } catch (e) {
                // Last resort: manual formatting
                const month = String(utcDate.getMonth() + 1).padStart(2, '0');
                const day = String(utcDate.getDate()).padStart(2, '0');
                const year = utcDate.getFullYear();
                let hours = utcDate.getHours();
                const minutes = String(utcDate.getMinutes()).padStart(2, '0');
                const seconds = String(utcDate.getSeconds()).padStart(2, '0');
                const ampm = hours >= 12 ? 'PM' : 'AM';
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                const hoursStr = String(hours).padStart(2, '0');
                
                formatted = `${month}/${day}/${year}, ${hoursStr}:${minutes}:${seconds} ${ampm}`;
            }
        }
        
        return formatted;
    } catch (error) {
        console.error('Error in processTimeStamp:', error, utcTime);
        // Last resort fallback
        try {
            const fallbackDate = new Date(utcTime);
            if (!isNaN(fallbackDate.getTime())) {
                return fallbackDate.toLocaleString("en-US");
            }
        } catch (e) {
            // Ignore
        }
        return 'Invalid Date';
    }
}

// SQLite stores "YYYY-MM-DD HH:MM:SS" with no timezone. Safari rejects that
// string, so parse UTC explicitly before any comparison or display.
export function parseNotificationTimestamp(timestamp) {
    if (timestamp == null || timestamp === '') {
        return null;
    }
    const raw = String(timestamp);
    let utcDate = new Date(raw + ' UTC');
    if (isNaN(utcDate.getTime())) {
        utcDate = new Date(raw.replace(' ', 'T') + 'Z');
    }
    if (isNaN(utcDate.getTime())) {
        utcDate = new Date(raw);
    }
    if (isNaN(utcDate.getTime())) {
        return null;
    }
    return utcDate;
}

export function processNotificationTimestamp(timestamp) {
    // Handle the notification timestamp format: "YYYY-MM-DD HH:MM:SS"
    // This format is assumed to be in UTC and needs conversion to CST
    
    try {
        const utcDate = parseNotificationTimestamp(timestamp);
        if (!utcDate) {
            if (timestamp) {
                console.error('Invalid date in processNotificationTimestamp:', timestamp);
            }
            return 'Invalid Date';
        }

        const options = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true,  // For AM/PM format
            timeZone: "America/Chicago" // Convert UTC time to Chicago time (Central Time)
        };

        // Use Intl.DateTimeFormat for better Safari compatibility
        // This is more reliable than toLocaleString in Safari on iOS
        let formatted;
        try {
            const formatter = new Intl.DateTimeFormat("en-US", options);
            formatted = formatter.format(utcDate);
        } catch (intlError) {
            // If Intl.DateTimeFormat fails, try toLocaleString
            formatted = utcDate.toLocaleString("en-US", options);
        }
        
        // Safari on iOS can return empty string or undefined - add fallback
        if (!formatted || formatted.trim() === '' || formatted === 'Invalid Date') {
            // Fallback: use basic formatting without timezone conversion
            // This ensures we always return something visible
            const fallbackOptions = {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true
            };
            
            try {
                const fallbackFormatter = new Intl.DateTimeFormat("en-US", fallbackOptions);
                formatted = fallbackFormatter.format(utcDate);
            } catch (e) {
                // Last resort: manual formatting
                const month = String(utcDate.getMonth() + 1).padStart(2, '0');
                const day = String(utcDate.getDate()).padStart(2, '0');
                const year = utcDate.getFullYear();
                let hours = utcDate.getHours();
                const minutes = String(utcDate.getMinutes()).padStart(2, '0');
                const seconds = String(utcDate.getSeconds()).padStart(2, '0');
                const ampm = hours >= 12 ? 'PM' : 'AM';
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                const hoursStr = String(hours).padStart(2, '0');
                
                formatted = `${month}/${day}/${year}, ${hoursStr}:${minutes}:${seconds} ${ampm}`;
            }
        }
        
        return formatted;
    } catch (error) {
        console.error('Error processing notification timestamp:', error, timestamp);
        // Last resort fallback
        try {
            const fallbackDate = new Date(timestamp);
            if (!isNaN(fallbackDate.getTime())) {
                return fallbackDate.toLocaleString("en-US");
            }
        } catch (e) {
            // Ignore
        }
        return 'Invalid Date';
    }
}